// Depends
import { route, subGroup, professionalMeta } from '@/helpers/routes'

import Registration from './me'

const routes = [
  route('me', '/me', Registration, professionalMeta('Meu Cadastro', true, 'professional'))
]

export default subGroup('/registration', routes)



// WEBPACK FOOTER //
// ./src/app/professional/record/registration/routes.js